import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
// import { Link as RouterLink } from 'react-router-dom';
import {
  // Avatar,
  Box,
  // Button,
  Divider,
  Drawer,
  Hidden,
  List,
  // Typography
} from "@material-ui/core";
import {
  // AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  BookOpen,
  MinusSquare,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
  Radio as RadioIcon,
  Trash,
} from "react-feather";
import NavItem from "../NavItem";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const user = {
  avatar: "/static/NFTENCER_logo.png",
  jobTitle: "Senior Developer",
  name: "Katarina Smith",
};

const items = [
  {
    href: "/app/customers",
    icon: UsersIcon,
    title: "User Information",
  },
  {
    href: "/app/dashboard",
    icon: BarChartIcon,
    title: "User Search",
  },
  {
    href: "/app/report",
    icon: UserIcon,
    title: "Report Request",
  },
  {
    href: "/app/item",
    icon: UserPlusIcon,
    title: "Item manager",
  },
  {
    href: "/app/itemblock",
    icon: BarChartIcon,
    title: "Item Blocked Manager",
  },
  {
    href: "/app/Userblock",
    icon: BookOpen,
    title: "User Blocked",
  },
  {
    href: "/app/products",
    icon: ShoppingBagIcon,
    title: "Trend View",
  },
  {
    href: "/app/event",
    icon: SettingsIcon,
    title: "Notice manager",
  },
  {
    href: "/app/banner",
    icon: RadioIcon,
    title: "Banner",
  },
  {
    href: "/app/category",
    icon: MinusSquare,
    title: "Category manager",
  },
  // {
  //   href: "/app/deleteNFT",
  //   icon: Trash,
  //   title: "Delete NFT",
  // },
  {
    href: "/login",
    icon: LockIcon,
    title: "Login",
  },
  // {
  //   href: '/register',
  //   icon: UserPlusIcon,
  //   title: 'Register'
  // },
  // {
  //   href: '/404',
  //   icon: AlertCircleIcon,
  //   title: 'Error'
  // }
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width <= 768;

  const content = (
    <Box
      sx={{
        height: 250,
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          p: 2,
        }}
      >
        <div>
          <a href="/app/customers">
            <img className="logo_sidebar" src={user.avatar} alt="description" />
          </a>
        </div>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256,
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      {!isMobile && (
        <Box
          component="nav"
          sx={{ width: { sm: 240 }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          <Drawer
            anchor="left"
            open
            variant="permanent"
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: 240,
              },
              position: "static",
            }}
          >
            {content}
          </Drawer>
        </Box>
      )}
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default DashboardSidebar;
